
export interface PlannerScaleConfig {
  scale: number
  slotSize: number
  canvasWidth: number
  sidebarWidth: number
  containerWidth: number
}

export function buildScaleConfig(scale: number): PlannerScaleConfig {
  const sidebarWidth = 250
  const canvasWidth = 1100 * scale
  const slotSize = 25 * scale
  const containerWidth = sidebarWidth + canvasWidth
  return {
    scale,
    slotSize,
    canvasWidth,
    sidebarWidth,
    containerWidth,
  }
}